import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

const StyledSectionTitle = styled.h2`
  font-family: ${theme.fonts.title};
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  color: ${theme.colors.outchou_blue};
  margin: 0;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 44px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 28px;
    line-height: 36px;
    text-align: left;
  }
`;


interface SectionTitleProps {
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
  return <StyledSectionTitle>{children}</StyledSectionTitle>;
};

export default SectionTitle;
